import React from "react";

interface TimeOffTypeBadgeProps {
  type: string;
}

const TimeOffTypeBadge: React.FC<TimeOffTypeBadgeProps> = ({ type }) => {
  if (!type) return null;
  
  const isDeductible = type === "deductible";

  return (
    <span
      className="badge rounded-pill fw-semibold border"
      style={
        isDeductible
          ? {
              backgroundColor: "#ffebe9",
              color: "#cf222e",
              borderColor: "#ffc1c0",
              fontSize: "10px",
            }
          : {
              backgroundColor: "#dafbe1",
              color: "#1a7f37",
              borderColor: "#aceebb",
              fontSize: "10px",
            }
      }
    >
      {isDeductible ? "Deductible" : "Non-deductible"}
    </span>
  );
};

export default TimeOffTypeBadge;
